import * as React from 'react';
import { NavItemProps } from '../../Navigator.type';
import { NavigatorMap } from '../../Navigator.map';

export function NavItem({
  feature,
  account,
  activeItem,
  pathName,
  onOpenSubmenu,
  schema
}: NavItemProps) {
  const hasSubmenu = schema?.items?.length > 0;
  const isActive = feature === activeItem;
  const featureUrl = NavigatorMap.buildFeatureUrl(account, feature);

  return (
    <li className={`nav-item ${isActive ? 'ativo' : ''} ${hasSubmenu ? 'submenu' : ''}`}>
      <a 
        href={featureUrl}
        onClick={(event) => {
          if (hasSubmenu) {
            onOpenSubmenu(event, feature);
          }
        }}
      >
        <i className={`fa-light fa-${schema?.icon}`}></i>
        <span>{schema?.label}</span>
      </a>
      
      {hasSubmenu && (
        <ul className="submenu">
          {schema.items?.map((item, index) => (
            <li 
              key={index} 
              className={NavigatorMap.isItemActive(pathName, account, item.url) ? 'ativo' : ''}
            >
              <a href={NavigatorMap.buildItemUrl(account, item.url)}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}
